import { KuikaAppManager } from "../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../shared/utilty/react-system-functions";

interface IRedirectToOptions {
  openInNewTab: boolean;
}

declare let window: any;

class HelperService {
  static getClientSecret(): string {
    return "a462c3e0a51d12ed2270231afe747029fe60abf262faaffcf4578ad357da7768";
  }

  static getClientId(): string {
    let appKey = "default";
    try {
      const backEndUrl = KuikaAppManager.GetBackendUrl(true) || "";
      const frontEndUrl = KuikaAppManager.GetFrontEndUrl() || "";
      appKey = `${frontEndUrl}|${backEndUrl}`.toLowerCase();
    } catch (_) {
      // ignore
    }

    const STORAGE_KEY = `kuika_client_id${appKey}`;

    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (existing && existing.trim().length > 0) return existing;

      const newId = HelperService.generateUuidV4();
      localStorage.setItem(STORAGE_KEY, newId);
      return newId;
    } catch (_) {
      return HelperService.generateUuidV4();
    }
  }

  private static generateUuidV4(): string {
    const c: any = (globalThis as any).crypto;
    if (c?.randomUUID) return c.randomUUID();

    const bytes = new Uint8Array(16);
    if (c?.getRandomValues) c.getRandomValues(bytes);
    else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  static redirectGotoStartingScreen = async (screen?: string) => {
    let screenName: string = ReactSystemFunctions.getScreenNameByActiveUserRoles();

    if (
      (screenName === "" || screenName === undefined) &&
      window.userInfo?.startingScreenId &&
      window.userInfo.startingScreenId.length > 0
    ) {
      screenName = ReactSystemFunctions.getScreenNameById(window.userInfo.startingScreenId);
    }

    if (screenName === "" || screenName === undefined) {
      HelperService.redirectToPath(screen ?? "/HomePage");
    } else {
      HelperService.redirectToPath(`/${screenName}`);
    }
  };

  static getIsInLoginPage(): boolean {
    return window.location.pathname.includes("/login");
  }

  static gotoLogin(redirectUri?: string) {
    var frontEnd = new URL(KuikaAppManager.GetFrontEndUrl());

    if (redirectUri && redirectUri.trim() !== "") {
      redirectUri = redirectUri.replace(frontEnd.pathname, "");
      const encodedUri = encodeURIComponent(redirectUri);
      HelperService.redirectToPath("/login" + `${redirectUri !== "/" ? `?redirectUri=${encodedUri}` : ""}`);
    } else {
      HelperService.redirectToPath("/login");
    }
  }

  static redirectToPath(path: string, options?: IRedirectToOptions): void {
    const isWebComponent = KuikaAppManager.IsWebComponent();

    if (isWebComponent) {
      const url = new URL(window.location.href);
      url.hash = path;
      HelperService.redirectToFullUrl(url.toString(), options);
    } else {
      const frontEndUrl = KuikaAppManager.GetFrontEndUrl();
      HelperService.redirectToFullUrl(`${frontEndUrl}${path}`, options);
    }
  }

  static redirectToFullUrl(url: string, options?: IRedirectToOptions): void {
    if (options?.openInNewTab) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      window.location.replace(url);
    }
  }
}

export default HelperService;
